import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Button from "@mui/material/Button";
import { Grid, FormControl, InputLabel, Select } from "@mui/material";

import {
  useAccount,
  useContractWrite,
  usePrepareContractWrite,
  useWaitForTransaction,
  useNetwork,
  useSwitchNetwork,
} from "wagmi";
import {
  prepareWriteContract,
  writeContract,
  readContract,
  waitForTransaction,
} from "@wagmi/core";
import {
  MARKETPLACE_ABI,
  MARKETPLACE_CONTRACT,
  ABI_USDT,
  USDT_CONTRACT,
} from "./components/marketplacecontracts";
import Web3 from "web3";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress, Snackbar } from "@material-ui/core";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Divider,
} from "@mui/material";
import MuiAlert from "@material-ui/lab/Alert";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Spring from "./components/Spring";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { CSSTransition } from "react-transition-group";
import "./animation.css";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles((theme) => ({
  style_container: {
    gap: "10px",
    justifyContent: "space-between",
    padding: "15px 10px",
  },
  smooth_container: {
    transition: "transform 0.3s",
  },
}));

const tabStyles = {
  "&.Mui-selected": {
    color: "#FFFFFF",
    backgroundColor: "#f8be24c7",
    height: "-webkit-fill-available",
    minHeight: "20px",
    maxHeight: "30px",
    borderRadius: "12px",
  },
  "&:not(.Mui-selected)": {
    height: "-webkit-fill-available",
    minHeight: "20px",
    maxHeight: "30px",
    borderRadius: "12px",
  },
  "&:.MuiTabs-centered": {
    borderRadius: "12px",
    border: "1px solid #bebebe",
    display: "block",
  },
};

const nftOptions = [
  {
    name: "CZT",
    imgUrl:
      "https://imagedelivery.net/0qhJEiI4Vh_ja_4EkR_5Ug/b36c74bd-f273-45b7-4b24-0c9960c1a400/public",
  },
  {
    name: "Taipei",
    imgUrl:
      "https://imagedelivery.net/0qhJEiI4Vh_ja_4EkR_5Ug/e516b1ea-a6c2-4948-f714-4a4922871b00/public",
  },
  {
    name: "TIANJIN",
    imgUrl:
      "https://imagedelivery.net/0qhJEiI4Vh_ja_4EkR_5Ug/7fd1a2f6-9771-477c-0d51-7722a1442300/public",
  },
  {
    name: "LWT",
    imgUrl:
      "https://imagedelivery.net/0qhJEiI4Vh_ja_4EkR_5Ug/bb739685-c033-47c6-7daf-2001f1180b00/public",
  },
];

function Marketplace() {
  const { address: walletAddress, connector, isConnected } = useAccount();
  const [selectedTab, setSelectedTab] = useState(0);
  const [nfts, setNfts] = useState({
    Taipei: [],
    CZT: [],
    Tianjin: [],
    LTW: [],
  });
  const [buyoffernfts, setbuyoffernfts] = useState({
    Taipei: [],
    CZT: [],
    Tianjin: [],
    LTW: [],
  });
  const [dataFetched, setDataFetched] = useState(false);
  const [stakedvalues, setstakedvalues] = useState(false);
  const tokens = [];
  const allTabLabels = ["CZT", "Taipei", "Tianjin", "LTW"];
  const classes = useStyles();
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogOffer, setOpenDialogOffer] = useState(false);

  const [newPrice, setNewPrice] = useState(0);
  const [NewPriceOffer, setNewPriceOffer] = useState(0);
  const [BuyOfferNFT, setBuyOfferNFT] = useState(null);
  const [BuyAmount, setBuyAmount] = useState(1);

  const [User, setUser] = useState(null);
  const [selectedNFT, setSelectedNFT] = useState(null);
  const [selectedNFTId, setSelectedNFTId] = useState(null);
  const [selectedNFTContract, setSelectedNFTContract] = useState(null);
  const [error, setError] = useState(null);
  const [success_message, setsuccess_message] = useState(null);
  const [loadingChangePrice, setloadingChangePrice] = useState(false);
  const [loadingCancelOffer, setloadingCancelOffer] = useState(false);
  const [loadingBuyOffer, setloadingBuyOffer] = useState(false);
  const [loadingMakeOffer, setloadingMakeOffer] = useState(false);
  const [loadingNFTIds, setLoadingNFTIds] = useState([]);
  const [loadingDeleteOffer, setloadingDeleteOffer] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [floorprice_taipei, setfloorprice_taipei] = useState(0);
  const [floorprice_czt, setfloorprice_czt] = useState(0);
  const [floorprice_ctf, setfloorprice_ctf] = useState(0);
  const [openTelegram, setOpenTelegram] = useState(false);
  const [telegramPin, setTelegramPin] = useState(null);
  const [loadingTelegram, setloadingTelegram] = useState(false);

  const handleCloseTelegram = () => {
    setOpenTelegram(false);
  };

  const navigate = useNavigate();

  const handleOpenMenu = (event) => setMenuAnchor(event.currentTarget);
  const handleCloseMenu = () => setMenuAnchor(null);

  const handleSellClick = () => {
    navigate("/dashboard");
  };

  const handleExpand = () => {
    setShowTable(!showTable);
    setIsExpanded(!isExpanded);
  };

  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleSnackbarClose = () => {
    setError(null);
    setsuccess_message(null);
  };

  const displayErrorAlert = (message) => {
    setError(message);
    setTimeout(() => {
      setError(null);
    }, 2000);
  };

  const displaySuccessAlert = (message) => {
    setsuccess_message(message);
    setTimeout(() => {
      setsuccess_message(null);
    }, 2000);
  };

  const tabLabels = Object.keys(nfts);

  useEffect(() => {
    const fetchData = async () => {
      if (!dataFetched) {
        try {
          console.log("fetchAvailableMarketItems");
          const NFT_ITEMS = await fetchAvailableMarketItems();

          console.log("NFT_ITEMS:", NFT_ITEMS);
          setNfts(NFT_ITEMS);

          const NFT_BUYOFFERS = await fetchMarketBuyOffers();
          console.log("NFT_BUYOFFERS:", NFT_BUYOFFERS);
          setbuyoffernfts(NFT_BUYOFFERS);

          setDataFetched(true);
        } catch (error) {
          console.error(error);
          // Handle any errors occurred during contract interaction
        }
      }
    };

    fetchData();
  }, [dataFetched]);

  const fetchMarketBuyOffers = async () => {
    try {
      console.log("fetchMarketBuyOffers:");
      const response = await axios.get(
        `https://test.croesus-asset.management/api/fetchAvailableMarketItems`
      );

      // Convert the response data into the desired format
      const convertedData = response.data.reduce((accumulator, item) => {
        const { nft_contract, price, amount, user, id, ...rest } = item;

        if (!accumulator[nft_contract]) {
          accumulator[nft_contract] = [];
        }

        accumulator[nft_contract].push({ ...rest, price, amount, user, id });

        return accumulator;
      }, {});

      console.log("Converted Data:", convertedData);
      return convertedData;
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchAvailableMarketItems = async () => {
    try {
      const NFT_ITEMS = await readContract({
        address: MARKETPLACE_CONTRACT,
        abi: MARKETPLACE_ABI,
        functionName: "fetchAvailableMarketItems",
      });
      console.log("NFT_ITEMS:", NFT_ITEMS);

      let price_feeInEther;
      const convertedNFT_ITEMS = NFT_ITEMS.map((obj) => {
        if (typeof obj.price === "bigint") {
          price_feeInEther = Web3.utils.fromWei(String(obj.price), "ether");

          return {
            ...obj,
            price: price_feeInEther,
          };
        }
        return obj;
      });

      console.log("convertedNFT_ITEMS:", convertedNFT_ITEMS);

      // Assuming each key in convertedNFT_ITEMS is a contract address
      const nfts = {};
      let nftsData = {};

      if (Array.isArray(convertedNFT_ITEMS)) {
        // Iterate through each converted NFT item and assign the cityName
        convertedNFT_ITEMS.forEach((item) => {
          let cityName;

          // -console.log("item:", item);
          if (
            item.nftContractAddress ===
              "0x21ebfBF52d2B35b3C091d60fc5942c41bCb259bD" ||
            item.nftContractAddress ===
              "0xB8C5552D640F77866874400c1F8685C5dA4D6406"
          ) {
            cityName = "Taipei";
          } else if (
            item.nftContractAddress ===
            "0x1F152781599eAD748b481514d6F620d06207875D"
          ) {
            cityName = "Tianjin";
          } else if (
            item.nftContractAddress ===
            "0x4c0a9e2BF684448039179e90a13E3148795cA162"
          ) {
            cityName = "CZT";
          } else if (
            item.nftContractAddress ===
              "0x64625c6585B90478c023F84a5Be7a5006A786F1D" ||
            item.nftContractAddress ===
              "0xe4eC65901613750E66FeDC0B314873E513a42c85"
          ) {
            cityName = "CZT";
          }
          // console.log("cityName:", cityName);

          // Create or update nfts with the cityName as key
          if (!nfts[cityName]) {
            nfts[cityName] = [];
          }

          tokens.push({
            tokenID: Number(item.tokenId),
            contractAddress: item.nftContractAddress,
          });

          // console.log("item.tokenId:", item.tokenId);
          // console.log("cityName:", cityName);
          // console.log("item.price:", item.price);
          nfts[cityName].push({
            id: Number(item.tokenId),
            marketID: Number(item.marketItemId),
            name: cityName,
            price: item.price,
            seller: item.seller,
            contractAddress: item.nftContractAddress,
          });
        });

        // console.log("nfts:", nfts);
        // console.log("tokens:", tokens);
        if (!dataFetched) {
          // Check if data has not been fetched

          if (tokens.length > 0) {
            console.log("axios post");
            axios
              .post(
                "https://test.croesus-asset.management/api/get_marketplace_nft",
                {
                  data: tokens,
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
                    "Access-Control-Allow-Headers":
                      "Origin, Content-Type, Accept, Authorization",
                  },
                }
              )
              .then((response) => {
                console.log("Response:", response.data);
                nftsData = response.data.nfts;
                setfloorprice_czt(response.data.marketplace_floor_czt);
                setfloorprice_taipei(response.data.marketplace_floor_taipei);
                setfloorprice_ctf(response.data.marketplace_floor_ctf);

                Object.keys(nftsData).forEach((tokenId) => {
                  Object.keys(nfts).forEach((cityName) => {
                    nfts[cityName].forEach((nftItem) => {
                      if (Number(nftItem.id) === Number(tokenId)) {
                        nftItem.stakingVolume = nftsData[tokenId];
                      }
                    });
                  });
                });
                setstakedvalues(true);
              })
              .catch((error) => {
                console.error("Error:", error);
              });
          }
        }
      }

      return nfts;
    } catch (error) {
      console.error(error);
      // Handle any errors occurred during contract interaction
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setloadingTelegram(true);
    console.log("Telegram Pin", telegramPin);
    axios
      .post(
        "https://test.croesus-asset.management/api/telegram_connect",
        {
          data: {
            user: walletAddress,
            pin: telegramPin,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
            "Access-Control-Allow-Headers":
              "Origin, Content-Type, Accept, Authorization",
          },
        }
      )
      .then((response) => {
        console.log("Response:", response.data);
        setsuccess_message("Telegram Bot connected successfully");
        setloadingTelegram(false);
        setTimeout(() => {
          window.location.reload(false);
        }, 2000);
      })
      .catch((error) => {
        console.error("Error:", error);
        setloadingTelegram(false);
        setError("Error please try again");
      });
  };

  const handleChangePrice = async () => {
    setloadingChangePrice(true);
    console.log("NFT ID :", selectedNFTId);
    console.log("Price to set :", newPrice);
    const weiPrice = Web3.utils.toWei(String(newPrice), "ether");
    console.log("Price to set in Wei:", weiPrice);

    try {
      const { request } = await prepareWriteContract({
        address: MARKETPLACE_CONTRACT,
        abi: MARKETPLACE_ABI,
        functionName: "changePrice",
        args: [selectedNFTId, weiPrice],
        account: walletAddress,
      });
      console.log("request:", request);
      const { hash } = await writeContract(request);
      console.log("hash:", hash);

      const data = await waitForTransaction({
        hash: hash,
      });
      console.log("data:", data);
      if (data) {
        setloadingChangePrice(false);
        displaySuccessAlert("Transaction successfull");
      }
    } catch (error) {
      if (error.message.includes("User rejected the request")) {
        displayErrorAlert("User rejected the request");
        setloadingChangePrice(false);
      } else {
        const errorMessage = error.message.split("\n")[1]; // Extract the first sentence
        console.error("errorMessage");
        console.error(errorMessage);
        displayErrorAlert(errorMessage);
        setloadingChangePrice(false);
      }
    }

    setNewPrice("");
    // setOpenDialog(false);
    setTimeout(() => {
      window.location.reload(false);
    }, 2000); // 2000 milliseconds = 2 seconds
  };

  const handleBuyNFT = async (nft) => {
    console.log("nft :", nft);
    try {
      // Add the NFT id to the array of loading NFT ids
      setLoadingNFTIds((prevLoadingNFTIds) => [...prevLoadingNFTIds, nft.id]);

      const approved_usdt = await readContract({
        address: USDT_CONTRACT,
        abi: ABI_USDT,
        functionName: "allowance",
        args: [walletAddress, MARKETPLACE_CONTRACT],
      });
      console.log("approved_usdt :", approved_usdt);

      let weiPrice = Web3.utils.toWei(String(nft.price), "ether");
      if (Number(approved_usdt) < weiPrice) {
        console.log("Need to approve more USDT");
        const { request: approveRequest } = await prepareWriteContract({
          address: USDT_CONTRACT,
          abi: ABI_USDT,
          functionName: "approve",
          args: [MARKETPLACE_CONTRACT, weiPrice],
          account: walletAddress,
        });
        console.log("approveRequest:", approveRequest);
        const { hash: approveHash } = await writeContract(approveRequest);
        console.log("approveHash:", approveHash);

        const approvedata = await waitForTransaction({
          hash: approveHash,
        });
        console.log("approvedata:", approvedata);
        if (approvedata) {
          const { request: buyRequest } = await prepareWriteContract({
            address: MARKETPLACE_CONTRACT,
            abi: MARKETPLACE_ABI,
            functionName: "pay_marketsale",
            args: [nft.contractAddress, Number(nft.marketID)],
            account: walletAddress,
          });
          console.log("buyRequest:", buyRequest);
          const { hash: buyHash } = await writeContract(buyRequest);
          console.log("buyHash:", buyHash);

          const buydata = await waitForTransaction({
            hash: buyHash,
          });
          console.log("buydata:", buydata);

          if (buydata) {
            setLoadingNFTIds((prevLoadingNFTIds) =>
              prevLoadingNFTIds.filter((id) => id !== nft.id)
            );
            displaySuccessAlert("Transaction successfull");
            setTimeout(() => {
              window.location.reload(false);
            }, 2000); // 2000 milliseconds = 2 seconds
          }
        }
      }
    } catch (error) {
      console.error("Error buying NFT:", error);
      // Remove the NFT id from the array of loading NFT ids in case of an error
      setLoadingNFTIds((prevLoadingNFTIds) =>
        prevLoadingNFTIds.filter((id) => id !== nft.id)
      );
    }
  };

  const setOpen = async () => {};

  const handleCancelOffer = async () => {
    setloadingCancelOffer(true);
    console.log("NFT ID :", selectedNFTId);
    console.log("NFT Contract :", selectedNFTContract);

    try {
      const { request } = await prepareWriteContract({
        address: MARKETPLACE_CONTRACT,
        abi: MARKETPLACE_ABI,
        functionName: "cancelMarketItem",
        args: [selectedNFTContract, selectedNFTId],
        account: walletAddress,
      });
      console.log("request:", request);
      const { hash } = await writeContract(request);
      console.log("hash:", hash);

      const data = await waitForTransaction({
        hash: hash,
      });
      console.log("data:", data);
      if (data) {
        // Code for successful promise fulfillment
        setloadingCancelOffer(false);
        displaySuccessAlert("Transaction successfull");
      }
    } catch (error) {
      if (error.message.includes("User rejected the request")) {
        displayErrorAlert("User rejected the request");
        setloadingCancelOffer(false);
      } else {
        const errorMessage = error.message.split("\n")[1]; // Extract the first sentence
        console.error("errorMessage");
        console.error(errorMessage);
        displayErrorAlert(errorMessage);
        setloadingCancelOffer(false);
      }
    }
    setTimeout(() => {
      window.location.reload(false);
    }, 2000); // 2000 milliseconds = 2 seconds
  };

  const handleMakeOffer = () => {
    setloadingMakeOffer(true);
    console.log("nft", selectedNFT);
    console.log("price", NewPriceOffer);

    axios
      .post(
        "https://test.croesus-asset.management/api/askprice",
        {
          data: {
            nft: selectedNFT,
            price: NewPriceOffer,
            user: walletAddress,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
            "Access-Control-Allow-Headers":
              "Origin, Content-Type, Accept, Authorization",
          },
        }
      )
      .then((response) => {
        console.log("Response:", response.data);
        displaySuccessAlert("Offer made successfully");
        setloadingMakeOffer(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        displayErrorAlert("Error please try again");
        setloadingMakeOffer(false);
      });
  };

  const handleDeleteOrder = (id) => {
    console.log("id", id);
    setloadingDeleteOffer(true);

    axios
      .post(
        "https://test.croesus-asset.management/api/deleteBuyOffer",
        {
          data: {
            id: id,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
            "Access-Control-Allow-Headers":
              "Origin, Content-Type, Accept, Authorization",
          },
        }
      )
      .then((response) => {
        console.log("Response:", response.data);
        displaySuccessAlert("Offer successfully deleted");
        setloadingDeleteOffer(false);
        setTimeout(() => {
          window.location.reload(false);
        }, 2000);
      })
      .catch((error) => {
        console.error("Error:", error);
        displayErrorAlert("Error please try again");
        setloadingDeleteOffer(false);
      });
  };

  const handleMenuButton = (nft) => {
    console.log("nft", nft);
    console.log("Price", NewPriceOffer);
    setSelectedNFT(nft);
    setOpenDialogOffer(true);
    handleCloseMenu();
  };

  const handleEditButton = (nftId, Contract) => {
    // Set the selectedNFTId state to the clicked NFT ID
    setSelectedNFTId(nftId);
    setSelectedNFTContract(Contract);

    // Open the dialog
    setOpenDialog(true);
  };

  const handleBuyOffer = () => {
    setloadingBuyOffer(true);
    console.log("BuyOfferNFT", BuyOfferNFT);
    console.log("newPrice", newPrice);
    console.log("BuyAmount", BuyAmount);

    axios
      .post(
        "https://test.croesus-asset.management/api/buy_offer",
        {
          data: {
            nft_contract: BuyOfferNFT,
            price: newPrice,
            user: walletAddress,
            amount: BuyAmount,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
            "Access-Control-Allow-Headers":
              "Origin, Content-Type, Accept, Authorization",
          },
        }
      )
      .then((response) => {
        console.log("Response:", response.data);
        displaySuccessAlert("Offer created successfully");
        setloadingBuyOffer(false);
        setTimeout(() => {
          window.location.reload(false);
        }, 2000); // 2000 mi
      })
      .catch((error) => {
        console.error("Error:", error);
        displayErrorAlert(error);
        setloadingBuyOffer(false);
        setTimeout(() => {
          window.location.reload(false);
        }, 2000); // 2000 mi
      });
  };

  const getImgUrlByNftName = (name) => {
    const selectedNft = nftOptions.find((nft) => nft.name === name);
    return selectedNft ? selectedNft.imgUrl : "";
  };

  useEffect(() => {
    if (isConnected) {
      axios
        .get(
          `https://test.croesus-asset.management/api/user-data?address=${walletAddress}`
        )
        .then((response) => {
          console.log("API RETURN: ", response);
          console.log("user: ", response.data.user);
          console.log("nfts: ", response.data.nftCounts);
          setUser(response.data.user);
        })
        .catch((error) => {
          console.error(error);
          if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            const errorMessage = error.response.data.error;
            console.log("Error message:", errorMessage);
            if (errorMessage === "User not found") {
            }
            // You can handle/display the error message as per your requirement
          }
        });
    } else {
      console.log("disconnected");
    }
  }, [isConnected]);

  return (
    <div className="p-2">
      <Snackbar
        open={error !== null}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity="error"
        >
          {error}
        </MuiAlert>
      </Snackbar>
      <Snackbar
        open={success_message !== null}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity="success"
        >
          {success_message}
        </MuiAlert>
      </Snackbar>

      {User && User.tele_id === null ? (
        <>
          <button
            className="btn btn-warning btn-lg btn-block mb-3"
            style={{
              margin: "0px auto",
              width: "fit-content",
              padding: "0px 11px",
              borderColor: "#24a1db",
              backgroundColor: "#24a1db",
            }}
            onClick={() => setOpenTelegram(true)}
          >
            Connect with Telegram Bot now!{" "}
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Telegram_logo.svg/1024px-Telegram_logo.svg.png"
              style={{ width: "47px", marginLeft: "8px" }}
            />
          </button>

          <Dialog
            open={openTelegram}
            onClose={handleCloseTelegram}
            aria-labelledby="telegram_modal"
            aria-hidden="true"
          >
            <DialogTitle id="telegram_modal">
              Connect to Marketplace Telegram Bot
            </DialogTitle>
            <form
              name="add-blog-post-form"
              id="add-blog-post-form"
              onSubmit={handleSubmit}
            >
              <DialogContent dividers>
                <h5>1. Start the Bot</h5>
                <p>
                  Click on the button below to initialize the connection to our
                  Marketplace Telegram Bot.
                </p>
                <div style={{ textAlign: "center" }}>
                  <a
                    className="navbar-brand"
                    target="_blank"
                    href="https://t.me/CroesusInfo_bot"
                    style={{ margin: "0px auto" }}
                  >
                    <img
                      className="brand-logo"
                      alt="modern admin logo"
                      src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Telegram_logo.svg/1024px-Telegram_logo.svg.png"
                      style={{
                        width: "55px",
                      }}
                    />
                  </a>
                </div>
                <hr />
                <h5>2. Enter the PIN Code</h5>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder="Telegram PIN"
                  name="pin"
                  onChange={(e) => setTelegramPin(e.target.value)}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleCloseTelegram}
                  variant="contained"
                  style={{ backgroundColor: "red" }}
                >
                  Close
                </Button>
                <Button type="submit" variant="contained">
                  {loadingTelegram ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    <>Submit</>
                  )}
                </Button>
              </DialogActions>
            </form>
          </Dialog>
        </>
      ) : (
        <>
          <Tabs
            sx={{
              "& .MuiTabs-flexContainer": {
                borderRadius: "12px",
                border: "1px solid rgb(208, 208, 208)",
                display: "flex",
                justifyContent: "space-between",
                backgroundColor: "white",
              },
              "& .MuiButtonBase-root": {
                padding: "5px",
                fontSize: "1rem",
              },
            }}
            value={selectedTab}
            onChange={handleChangeTab}
            centered
            TabIndicatorProps={{
              style: {
                backgroundColor: "#0000",
                maxHeight: "30px",
              },
            }}
          >
            {allTabLabels.map((label, index) => (
              <Tab key={label} label={label} sx={tabStyles} />
            ))}
          </Tabs>

          <div
            className={
              classes.smooth_container + " style_container card bordered"
            }
            style={{ border: "1px solid #d0d0d0" }}
          >
            <div className={classes.style_container}>
              <h1 className="text-center">Create Buy Offer</h1>

              <div className="text-center">
                {isExpanded ? (
                  <ExpandLessIcon onClick={handleExpand} />
                ) : (
                  <ExpandMoreIcon onClick={handleExpand} />
                )}
              </div>

              <CSSTransition
                in={showTable}
                timeout={500}
                classNames="fade"
                unmountOnExit
              >
                <Grid
                  container
                  alignItems="center"
                  justifyContent="center"
                  spacing={2}
                  className={`mt-2 ${showTable ? "fadeIn" : ""}`}
                >
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <InputLabel id="nft_amount_label">Amount</InputLabel>
                      <Select
                        labelId="nft_amount_label"
                        id="nft_amount_select"
                        label="Amount"
                        onChange={(e) => setBuyAmount(e.target.value)}
                      >
                        {Array.from({ length: 10 }, (_, index) => (
                          <MenuItem key={index + 1} value={index + 1}>
                            {index + 1}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={5}>
                    <FormControl fullWidth>
                      <InputLabel id="nftSelectLabel">Select NFT</InputLabel>
                      <Select
                        labelId="nftSelectLabel"
                        id="nftSelect"
                        label="Select NFT"
                        onChange={(e) => setBuyOfferNFT(e.target.value)}
                        // value={nftOptions[0].name}
                      >
                        {nftOptions.map((option) => (
                          <MenuItem key={option.name} value={option.name}>
                            <img
                              src={option.imgUrl}
                              alt={option.name}
                              style={{ maxHeight: "20px", marginRight: "1rem" }}
                            />
                            {option.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      label="Price (in USDT)"
                      id="priceInput"
                      type="number"
                      onChange={(e) => setNewPrice(e.target.value)}
                    />
                  </Grid>
                  {loadingBuyOffer && (
                    <Grid item xs={12}>
                      <div className="text-center">
                        <CircularProgress
                          size={24}
                          color="inherit"
                          className="mt-3"
                        />
                      </div>
                    </Grid>
                  )}
                  <Grid item xs={12} className="text-center">
                    <Typography variant="h5" component="h2">
                      {BuyOfferNFT === "Taipei" ? (
                        <div>Floor Price: {floorprice_taipei} USDT</div>
                      ) : BuyOfferNFT === "CZT" ? (
                        <div>Floor Price: {floorprice_czt} USDT</div>
                      ) : BuyOfferNFT === "TIANJIN" ? (
                        <div>Floor Price: {floorprice_ctf} USDT</div>
                      ) : (
                        <div>Floor Price: n/a</div>
                      )}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      style={{ backgroundColor: "#f8be24" }}
                      onClick={() => handleBuyOffer()}
                    >
                      Create Offer
                    </Button>
                  </Grid>
                </Grid>
              </CSSTransition>
            </div>
          </div>

          <div className="d-flex flex-column g-8 text-center">
            {allTabLabels.map((tabLabel, index) => (
              <>
                <div key={"s" + tabLabel + index}>
                  {selectedTab === index &&
                    dataFetched &&
                    (Array.isArray(buyoffernfts[tabLabel]) &&
                    buyoffernfts[tabLabel].length > 0
                      ? buyoffernfts[tabLabel].map((nft, i) => (
                          <Spring type="list" index={i} key={i}>
                            <div
                              className={
                                classes.smooth_container +
                                " style_container card bordered"
                              }
                              style={{
                                border: "1px solid #d0d0d0",
                              }}
                            >
                              <div className="d-flex align-items-center flex-grow-1 justify-content-between">
                                <div className={classes.style_container}>
                                  <div className="makeStyles-nfticon-28">
                                    <img
                                      src={getImgUrlByNftName(tabLabel)}
                                      alt="Taipei"
                                      style={{ maxHeight: "25px" }}
                                    />
                                  </div>
                                </div>
                                <div className={classes.style_container}>
                                  BUY OFFER
                                </div>
                                <div className={classes.style_container}>
                                  {nft.amount} x
                                </div>
                                <div className={classes.style_container}>
                                  {nft.price} USDT
                                </div>
                                <div className={classes.style_container}>
                                  {walletAddress.toLowerCase() !==
                                  nft.user.toLowerCase() ? (
                                    <Button
                                      variant="contained"
                                      style={{ backgroundColor: "#f8be24" }}
                                      onClick={handleSellClick}
                                    >
                                      SELL
                                    </Button>
                                  ) : (
                                    <Button
                                      variant="contained"
                                      style={{
                                        backgroundColor: "rgb(25, 118, 210)",
                                      }}
                                      onClick={() => handleDeleteOrder(nft.id)}
                                    >
                                      {loadingDeleteOffer ? (
                                        <CircularProgress
                                          size={24}
                                          color="inherit"
                                        />
                                      ) : (
                                        <>DELETE</>
                                      )}
                                    </Button>
                                  )}
                                </div>
                              </div>
                              <div className="style_group__7Tj9f d-flex align-items-center"></div>
                            </div>
                          </Spring>
                        ))
                      : null)}
                </div>
              </>
            ))}
          </div>

          <div className="d-flex flex-column g-8 text-center">
            {dataFetched ? (
              <div
                className="p-3"
                style={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <p className="d-inline-flex align-items-center g-4 text-10 text-600">
                  NFT
                </p>
                <p className="d-inline-flex align-items-center g-4 text-10 text-600">
                  ID
                </p>
                <p className="d-inline-flex align-items-center g-4 text-10 text-600">
                  Staking Volume
                </p>
                <p className="d-inline-flex align-items-center g-4 text-10 text-600">
                  Price
                </p>
                <p className="d-inline-flex align-items-center g-4 text-10 text-600">
                  Action
                </p>
              </div>
            ) : null}

            {allTabLabels.map((tabLabel, index) => (
              <>
                {tabLabels.includes(tabLabel) ? (
                  <div key={"t" + tabLabel + index}>
                    {selectedTab === index &&
                      dataFetched &&
                      (Array.isArray(nfts[tabLabel]) &&
                      nfts[tabLabel].length > 0
                        ? nfts[tabLabel].map((nft, i) => (
                            <Spring type="list" index={i} key={i}>
                              <div
                                className={
                                  classes.smooth_container +
                                  " style_container card bordered"
                                }
                                style={{
                                  border: "1px solid #d0d0d0",
                                }}
                              >
                                <div className="d-flex align-items-center flex-grow-1 justify-content-between">
                                  <div className={classes.style_container}>
                                    <div className="makeStyles-nfticon-28">
                                      <img
                                        src={getImgUrlByNftName(tabLabel)}
                                        alt="Taipei"
                                        style={{ maxHeight: "25px" }}
                                      />
                                    </div>
                                  </div>
                                  <div className={classes.style_container}>
                                    #{nft.id}
                                  </div>
                                  <div className={classes.style_container}>
                                    {nft.stakingVolume} USDT
                                  </div>
                                  <div className={classes.style_container}>
                                    {nft.price} USDT
                                  </div>
                                  <div className={classes.style_container}>
                                    {nft.seller !== walletAddress ? (
                                      <div id={`nft-${nft.id}`}>
                                        {loadingNFTIds.includes(nft.id) ? (
                                          <CircularProgress
                                            size={24}
                                            color="inherit"
                                            className="mt-3"
                                          />
                                        ) : (
                                          <div>
                                            <Button
                                              variant="contained"
                                              style={{
                                                backgroundColor: "#f8be24",
                                              }}
                                              onClick={handleOpenMenu}
                                            >
                                              <MoreHorizIcon />
                                            </Button>
                                            <Menu
                                              anchorEl={menuAnchor}
                                              keepMounted
                                              open={Boolean(menuAnchor)}
                                              onClose={handleCloseMenu}
                                            >
                                              <MenuItem
                                                style={{
                                                  borderBottom:
                                                    "1px solid #d0d0d0",
                                                  textTransform: "uppercase",
                                                }}
                                                onClick={() =>
                                                  handleBuyNFT(nft)
                                                }
                                              >
                                                Buy
                                              </MenuItem>
                                              <MenuItem
                                                style={{
                                                  textTransform: "uppercase",
                                                }}
                                                onClick={() =>
                                                  handleMenuButton(nft)
                                                }
                                              >
                                                Make Offer
                                              </MenuItem>
                                            </Menu>
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      <Button
                                        variant="contained"
                                        style={{
                                          backgroundColor: "rgb(25, 118, 210)",
                                        }}
                                        onClick={() =>
                                          handleEditButton(
                                            nft.marketID,
                                            nft.contractAddress
                                          )
                                        }
                                      >
                                        Edit
                                      </Button>
                                    )}
                                  </div>
                                </div>
                                <div className="style_group__7Tj9f d-flex align-items-center"></div>
                              </div>
                            </Spring>
                          ))
                        : null)}
                  </div>
                ) : selectedTab === index ? (
                  <h4 style={{ marginBottom: "75px" }}>No NFTs listed</h4>
                ) : null}
              </>
            ))}
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
              <DialogTitle className="text-center">Edit NFT Price</DialogTitle>
              <DialogContent>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      marginBottom: "1rem",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <TextField
                      InputLabelProps={{
                        sx: {
                          marginTop: "10px",
                        },
                      }}
                      label="New Price"
                      value={newPrice}
                      onChange={(e) => setNewPrice(e.target.value)}
                      InputProps={{ endAdornment: "USDT" }}
                    />
                    <br></br>
                    {loadingChangePrice && (
                      <CircularProgress
                        size={24}
                        color="inherit"
                        className="mt-3"
                      />
                    )}
                    <Button
                      variant="contained"
                      onClick={handleChangePrice}
                      style={{ backgroundColor: "#f8be24", marginTop: "1rem" }}
                    >
                      Change Price
                    </Button>
                  </div>
                  <Divider style={{ marginBottom: "1rem", width: "100%" }} />

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column", // Added this line
                      alignItems: "center", // Align items at center along horizontal axis
                      width: "100%",
                    }}
                  >
                    {loadingCancelOffer && (
                      <CircularProgress
                        size={24}
                        color="inherit"
                        className="mt-3"
                      />
                    )}
                    <Button
                      variant="contained"
                      onClick={handleCancelOffer}
                      style={{ backgroundColor: "red", marginTop: "1rem" }}
                    >
                      Cancel Sell
                    </Button>
                  </div>
                </div>
              </DialogContent>
            </Dialog>
          </div>

          {/* <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>NFT</TableCell>
              <TableCell>ID</TableCell>
              <TableCell>Staking Volume</TableCell>
              <TableCell>Price</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(nfts[tabLabels[selectedTab]]) ? (
              nfts[tabLabels[selectedTab]].map((nft) => (
                <TableRow key={nft.id}>
                  <TableCell>
                    <div className="makeStyles-nfticon-28">
                      <img
                        src="https://imagedelivery.net/0qhJEiI4Vh_ja_4EkR_5Ug/e516b1ea-a6c2-4948-f714-4a4922871b00/public"
                        alt="Taipei"
                        style={{ maxHeight: "25px" }}
                      ></img>
                    </div>
                  </TableCell>
                  <TableCell>#{nft.id}</TableCell>
                  <TableCell>{nft.stakingVolume} USDT</TableCell>
                  <TableCell>{nft.price} USDT</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      style={{ backgroundColor: "#f8be24" }}
                    >
                      Buy
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5}>No NFTs available</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer> */}

          <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
            <DialogTitle className="text-center">Edit NFT Price</DialogTitle>
            <DialogContent>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    marginBottom: "1rem",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <TextField
                    InputLabelProps={{
                      sx: {
                        marginTop: "8px",
                      },
                    }}
                    label="New Price"
                    value={newPrice}
                    onChange={(e) => setNewPrice(e.target.value)}
                    InputProps={{ endAdornment: "USDT" }}
                  />
                  <br></br>
                  {loadingChangePrice && (
                    <CircularProgress
                      size={24}
                      color="inherit"
                      className="mt-3"
                    />
                  )}
                  <Button
                    variant="contained"
                    onClick={handleChangePrice}
                    style={{ backgroundColor: "#f8be24", marginTop: "1rem" }}
                  >
                    Change Price
                  </Button>
                </div>
                <Divider style={{ marginBottom: "1rem", width: "100%" }} />

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column", // Added this line
                    alignItems: "center", // Align items at center along horizontal axis
                    width: "100%",
                  }}
                >
                  {loadingCancelOffer && (
                    <CircularProgress
                      size={24}
                      color="inherit"
                      className="mt-3"
                    />
                  )}
                  <Button
                    variant="contained"
                    onClick={handleCancelOffer}
                    style={{ backgroundColor: "red", marginTop: "1rem" }}
                  >
                    Cancel Sell
                  </Button>
                </div>
              </div>
            </DialogContent>
          </Dialog>

          <Dialog
            open={openDialogOffer}
            onClose={() => setOpenDialogOffer(false)}
          >
            <DialogTitle className="text-center">Make Offer</DialogTitle>
            <DialogContent>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    marginBottom: "1rem",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <TextField
                    label="New Price"
                    InputLabelProps={{
                      sx: {
                        marginTop: "8px",
                      },
                    }}
                    value={NewPriceOffer}
                    onChange={(e) => setNewPriceOffer(e.target.value)}
                    InputProps={{ endAdornment: "USDT" }}
                  />
                  <br></br>
                  {loadingMakeOffer && (
                    <CircularProgress
                      size={24}
                      color="inherit"
                      className="mt-3"
                    />
                  )}
                  <Button
                    variant="contained"
                    onClick={handleMakeOffer}
                    style={{
                      backgroundColor: "#f8be24",
                      marginTop: "1rem",
                    }}
                  >
                    Make Offer
                  </Button>
                </div>
              </div>
            </DialogContent>
          </Dialog>
        </>
      )}
    </div>
  );
}

export default Marketplace;
